import React, { memo } from "react";
import { PreviousWorksData } from "./PreviousWorks.data";
import Image from "./layout/Image";
import Card from "./layout/Card";

const PreviousWorks = ( props: any ) => {
    return (
        <section
            id={ 'PreviousWorks' }
            className={ 'pt-12 md:px-32 pb-32' }
        >
            <h3 className={ `text-3xl text-center` }>Previous Works</h3>
            <p className={ `text-lg mb-20 text-gray-500 text-center` }>What Projects I Have Created?</p>
            <div className={ `grid grid-cols-auto-400 gap-10` }>
                { PreviousWorksData.map( e => (
                    <Card
                        key={e.name}
                        textNormal={ true }
                        imgSrc={ e.img }
                        fullImage={ true }
                        imgAlt={ e.name }
                    >
                        <div className={ `flex justify-between px-2` }>
                            <article>
                                <header>
                                    <h3 className={ `text-xl font-normal` }>{ e.name }</h3>
                                    <small className={`text-gray-600`}>{e.description}</small>
                                </header>
                                <footer className={ `flex flex-wrap gap-3 m-3` }>

                                    { e.tags.map( tag =>
                                        <span className={ 'bg-blue-200 rounded p-1' }>{ tag }</span>
                                    ) }
                                </footer>
                            </article>
                            <div className={ `flex items-center flex-col gap-3 py-2` }>
                                { e.hasPreview ? <a
                                    href={ e.link }
                                    target={ '_blank' }
                                    className="btn w-[90px] text-center btn-success btn-xs"
                                >Preview <i className={ `bi bi-eye-fill` } /></a> : '' }
                                { e.hasDocumentation ? <a
                                    href={ e.documentationUrl }
                                    target={ '_blank' }
                                    className="btn w-[160px] text-center btn-success btn-xs"
                                >Documentation <i className={ `bi bi-arrow-right` } /></a> : '' }
                                { e.hasSource ? <a
                                    href={ e.sourceLink }
                                    target={ '_blank' }
                                    className="btn w-[90px] text-center btn-primary btn-xs"
                                >Source <i className={ `bi bi-arrow-right` } /></a> : '' }
                            </div>

                        </div>
                    </Card>
                ) ) }
            </div>

        </section>
    )
}
export default memo( PreviousWorks )